module.exports = __webpack_public_path__ + "static/media/instructions_2.c77f4b7d.svg";